/* eslint-disable camelcase */
import Modal from "@/components/modal/modal.vue";
import BrowseOutletItems from "@/components/browseOutletItems/browseOutletItems.vue";
import { SettingsService } from "@/services/settingsApi";
import draggable from "vuedraggable";
import { createNamespacedHelpers } from "vuex";
import addRemoveTrackedItem from "@/components/addRemoveTrackedItem/addRemoveTrackedItem.vue";
import { MyGoalService } from "@/services/myGoalsApi";

import moment from "moment";

const { mapActions: userActions } = createNamespacedHelpers("user");

export default {
	components: {
		draggable,
		Modal,
		BrowseOutletItems,
		addRemoveTrackedItem,
	},

	data() {
		return {
			selectedLabels: [],
			showRemoveModal: false,
			labelToRemove: null,
		};
	},

	async created() {
		// get all tracked labels (also the ones that ended already)
		const { data } = await MyGoalService.getCurrentlyTrackedItems(),
			labels = data.tracked_labels || [];

		// copy only necessary fields
		this.selectedLabels = labels.map((label) => ({
			label_id: label.label_id,
			group: label.group,
			subgroup: label.subgroup,
			description: label.description,
			start_date: label.start_date,
			end_date: label.end_date,
			edited: false,
		}));
	},

	methods: {
		addSelectedLabel,
		removeLabel,
		onClickRemoveLabel,
		save,

		...userActions(["getMe"]),
	},
};

function addSelectedLabel(label, startDate) {
	// remove old tracking (if exists)
	this.selectedLabels = this.selectedLabels.filter((selectedLabel) => selectedLabel.label_id !== label.label_id);

	// add new tracking
	this.selectedLabels = [
		...this.selectedLabels,
		{
			label_id: label.label_id,
			group: label.group,
			subgroup: label.subgroup,
			description: label.description,
			start_date: moment(startDate).format("YYYY-MM-DD"),
			edited: true,
		},
	];
}

function removeLabel(labelId, endDate) {
	// we keep the item in selectedLabels even after removal, as end_date has to be saved
	Object.assign(this.selectedLabels.filter((selectedLabel) => selectedLabel.label_id === labelId)[0], {
		end_date: moment(endDate).format("YYYY-MM-DD"),
		edited: true,
	});
	this.selectedLabels = [...this.selectedLabels];
}

async function save() {
	try {
		const labels = this.selectedLabels.map((label) => ({
			label_id: label.label_id,
			start_date: label.start_date,
			end_date: label.end_date,
			edited: label.edited,
		}));

		await SettingsService.setOutletTrackedLabels(labels);
		this.getMe();
		this.$eventBus.$emit("reloadTrackedItemsData");
		this.$emit("close");
	} catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}

function onClickRemoveLabel(label) {
	this.labelToRemove = {
		label_id: label.label_id,
		start_date: moment(label.start_date, "YYYY-MM-DD"),
		translations: label.description.translations,
	};
	this.showRemoveModal = true;
}
